import React from "react"
import { InteractiveTerminal } from "./InteractiveTerminal"

import styled from "styled-components"

const StyledSlalom = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;
  @media (max-width: 1100px) {
    justify-content: center;
  }
`

const ContentDiv = styled.div`
  max-width: 500px;
  display: flex;
  flex-direction: column;
  & a {
    font-size: 18px;
    text-decoration: none;
    color: #6e60f9;
    inline-size: fit-content;
  }
  & p {
    margin: 10px 0 32px 0;
  }
  @media (min-width: 768px) {
    margin: auto;
    margin-left: 0;
  }
`

const Slalom = ({ header, content, link, codeLanguages }) => {
  return (
    <StyledSlalom>
      <ContentDiv>{content}</ContentDiv>
      <InteractiveTerminal codeLanguages={codeLanguages} />
    </StyledSlalom>
  )
}

export default Slalom
